<template>
  <div style="position: absolute; top: calc(50% - 25px); left: calc(50% - 25px)">
    <v-progress-circular indeterminate color="primary" :size="50"></v-progress-circular>
  </div>
</template>